import { useAppSelector } from '@common/hooks'
import cx from 'classnames'
import Modal from 'react-modal'
import type { SwiperClass } from 'swiper/react'

import classNames from './styles.module.scss'


interface IProps {
  activeElem: number | null,
  screenshots: string[],
  show: boolean,
  onHide: () => void,
  [keyof: string]: any,
  setActiveScreenshot: (ind: number | null) => void,
  slider?: SwiperClass,
}

export default function ModalScreenshot({
  activeElem,
  screenshots,
  show,
  onHide,
  setActiveScreenshot,
  slider,
}: IProps): JSX.Element {
  const validBasePath = useAppSelector(store => store.common.data.config?.IMAGE_DOMAIN) as string
  const newUrl = activeElem !== null ? `${validBasePath}${validBasePath.endsWith('/') ? '' : '/'}${screenshots[activeElem]}` : ''
  return (
    <div className={classNames.wrapper} data-test="modal-body-screenshots">
      <Modal
        isOpen={show}
        closeTimeoutMS={500}
        ariaHideApp={false}
        onRequestClose={onHide}
        className={classNames.modal}
        overlayClassName={classNames.mask}
      >
        <div className={classNames.wrapperContent}>
          <img
            src={newUrl}
            className={classNames.img}
            data-test="modal-screenshot"
          />
        </div>
        {screenshots.length > 1 && (
          <>
            <button
              className={cx(classNames.button, {
                [classNames.disabled]: activeElem === 0,
              })}
              data-test="modal-btn-screenshot-prev"
              onClick={() => {
                if(activeElem !== null && activeElem > 0) {
                  setActiveScreenshot(activeElem - 1)
                  slider && slider.slideTo(activeElem - 1, 500)
                }
              }}
            />
            <button
              className={cx(classNames.button, {
                [classNames.disabled]: activeElem === screenshots.length - 1,
              })}
              data-test="modal-btn-screenshot-next"
              onClick={() => {
                if(activeElem !== null && activeElem < screenshots.length - 1) {
                  setActiveScreenshot(activeElem + 1)
                  slider && slider.slideTo(activeElem + 1, 500)
                }
              }}
            />
          </>
        )}
      </Modal>
    </div>
  )
}
